import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin } from 'antd';
import moment from 'moment';
import { data3_2_1 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import ExportExcel from "@/method/components/ExportExcel"
const { MonthPicker } = DatePicker;


class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        const naeData = ['outlets', 'seats', 'available', 'covers', 'revenue'];
        let toi_ranking = [];
        let ACI_ranking = [];
        let RGI_ranking = [];

        for (let i = 0; i < 5; i++) {
            data[5][naeData[i]] = naeData.reduce((a, b, index) => {
                a += numConvert(data[index][naeData[i]]);
                return a
            }, 0);
            toi_ranking.push({
                data: Number(data[i].toi || '0'),
                key: i
            });
            ACI_ranking.push({
                data: Number(data[i].ACI || '0'),
                key: i
            });
            RGI_ranking.push({
                data: Number(data[i].RGI || '0'),
                key: i
            });
            data[5][naeData[i]] = data[5][naeData[i]].toFixed(2);
        }

        for (let i = 0; i < data.length; i++) {
            // 上座率
            data[i].turn_over = (numConvert(data[i].available) == 0 ? 0 : numConvert(data[i].covers) / numConvert(data[i].available)).toFixed(3);
            // 人均消费
            data[i].AC = (numConvert(data[i].covers) == 0 ? 0 : numConvert(data[i].revenue) / numConvert(data[i].covers)).toFixed(2);
            // 可售餐位平均收入
            data[i].revpas = (numConvert(data[i].available) == 0 ? 0 : numConvert(data[i].revenue) / numConvert(data[i].available)).toFixed(2);
        };

        for (let i = 0; i < (data.length - 1); i++) {
            //  上座率指数
            data[i].toi = (numConvert(data[5].turn_over) == 0 ? 0 : numConvert(data[i].turn_over) / numConvert(data[5].turn_over)).toFixed(2);
            //   人均消费指数
            data[i].ACI = (numConvert(data[5].AC) == 0 ? 0 : numConvert(data[i].AC) / numConvert(data[5].AC)).toFixed(2);
            //   收益率指数
            data[i].RGI = (numConvert(data[5].revpas) == 0 ? 0 : numConvert(data[i].revpas) / numConvert(data[5].revpas)).toFixed(2);
        }


        // 计算排名
        toi_ranking.sort((a, b) => {
            return b.data - a.data
        });
        ACI_ranking.sort((a, b) => {
            return b.data - a.data
        });
        RGI_ranking.sort((a, b) => {
            return b.data - a.data
        });

        toi_ranking.forEach((x, i) => {
            data[x.key].toi_ranking = i + 1;
        });
        ACI_ranking.forEach((x, i) => {
            data[x.key].ACI_ranking = i + 1;
        });
        RGI_ranking.forEach((x, i) => {
            data[x.key].RGI_ranking = i + 1;
        });

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        // this.setState({
        //     data
        // });
        this.computeNum(data);
    }

    getDateData = async (date) => {

        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);

        let d = await fetch(`/_3_1_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' });
        let data3_1 = await d.json();
        fetch(`/_3_2_2_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            if (data3_1.data && data3_1.data.length > 0) {
                data = data.map((item, index) => {
                    if (index != data.length - 1) {
                        return ({ ...item, name: data3_1.data[index].name, name_code: data3_1.data[index].name_code })
                    }
                    return ({ ...item, })
                })
            }

            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        // if (!data.every(x => x.name)) {
        //     message.error('名称不能为空，请到3-1-1设置名称！');
        //     return
        // }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_3_2_2  ', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_2_2', 1.5, '5.72', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, date, print } = this.state;
        const width = document.body.offsetWidth - 2100 > 400 ? document.body.offsetWidth - 2100 : 400;
        const columns = [{
            title: 'Comp Set 竞争集群',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: !print && "left",
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div>No. of Outlets <br />餐厅数</div>,
            dataIndex: 'outlets',
            key: 'outlets',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (index != 5 && !print) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('outlets', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }

            }
        }, {
            title: <div>No. of Seats <br />餐位数</div>,
            dataIndex: 'seats',
            key: 'seats',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (index != 5 && !print) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('seats', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }

            }
        }, {
            title: <div>Seats Available <br />可售餐位</div>,
            dataIndex: 'available',
            key: 'available',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (index != 5 && !print) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('available', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }

            }
        }, {
            title: <div>No. of Covers<br />用餐人数</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (index != 5 && !print) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('covers', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }

            }
        }, {
            title: <div>Turn Over<br /> 上座率/翻台率</div>,
            dataIndex: 'turn_over',
            key: 'turn_over',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                    </div>
                )
            }
        }, {
            title: <div>Outlets Revenue<br /> 餐厅收入</div>,
            dataIndex: 'revenue',
            key: 'revenue',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                if (index != 5 && !print) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ''}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('revenue', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }

            }
        }, {
            title: <div>A/C 人均消费</div>,
            dataIndex: 'AC',
            key: 'AC',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }, {
            title: <div>RevPAS <br /> 可售餐位平均收入</div>,
            dataIndex: 'revpas',
            key: 'revpas',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }, {
            title: <div>TOI 上座率指数</div>,
            dataIndex: 'toi',
            key: 'toi',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }, {
            title: <div>Ranking 排名</div>,
            dataIndex: 'toi_ranking',
            key: 'toi_ranking',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }, {
            title: <div>ACI 人均消费指数</div>,
            dataIndex: 'ACI',
            key: 'ACI',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }, {
            title: <div>Ranking 排名</div>,
            dataIndex: 'ACI_ranking',
            key: 'ACI_ranking',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }, {
            title: <div>RGI 收益率指数</div>,
            dataIndex: 'RGI',
            key: 'RGI',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }, {
            title: <div>Ranking 排名</div>,
            dataIndex: 'RGI_ranking',
            key: 'RGI_ranking',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )

            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table3_2_2" style={{ width: this.state.print ? 2550 : 'auto' }}>
                        <Row>5.7.2 YTD This  Year 本年累计</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, 'YYYY-MM')}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="export5_7_2"
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 2500 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 2500, y: 550 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {

                                this.setState({ print: true, loading: true }, () => {
                                    ExportExcel({
                                        id: "export5_7_2",
                                        date,
                                        name: "5.7.2 YTD This Year 本年累计"
                                    });
                                    this.setState({ print: false, loading: false });
                                });

                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_3_2">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>


                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/3.0/3-2/3-2-2.js